export default {
    title: "",
    unavailable: "Tento produkt již není dostupný."
}